import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrentUserResponseDto, UpdateCurrentUserRequestDto, UserDto } from '../models/user-dto.model';
import { AppConfigService } from '../config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private appConfig = inject(AppConfigService);

  private get baseUrl(): string {
    return `${this.appConfig.backendUrl}/api/v1/users`;
  }

  private get currentUserUrl(): string {
    return `${this.appConfig.backendUrl}/api/v1/user`;
  }

  constructor(private http: HttpClient) {}

  getUsers(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(this.baseUrl);
  }

  getCurrentUserProfile(): Observable<CurrentUserResponseDto> {
    return this.http.get<CurrentUserResponseDto>(this.currentUserUrl);
  }

  saveCurrentUserProfile(body: UpdateCurrentUserRequestDto): Observable<unknown> {
    return this.http.put<unknown>(this.currentUserUrl, body);
  }
}
